import publishingWarnings from '../constants/publishing-warnings';

const hasUntranslatedCustomCodeWarning = (warnings = []) =>
  warnings.includes(publishingWarnings.UNTRANSLATED_CUSTOM_CODE);

export default hasUntranslatedCustomCodeWarning;
